// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-page-container {
  position: relative;
  min-height: 100vh;
  padding: 1rem 0;
}
.users-page-container .page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--cui-border-color, #d8dbe0);
}
.users-page-container .page-header .page-title {
  flex: 1 1;
}
.users-page-container .page-header .page-title h2 {
  color: var(--cui-body-color);
  font-weight: 600;
  font-size: 1.75rem;
  margin-bottom: 0.25rem;
}
.users-page-container .page-header .page-title .text-muted {
  font-size: 0.875rem;
  color: var(--cui-secondary-color, #8a93a2);
}
.users-page-container .page-header .page-actions {
  flex-shrink: 0;
}
.users-page-container .page-header .page-actions .btn {
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: all 0.2s ease;
}
.users-page-container .page-header .page-actions .btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.users-page-container .create-user-fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  border: none;
}
.users-page-container .create-user-fab:hover {
  transform: scale(1.1);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}
.users-page-container .create-user-fab:active {
  transform: scale(0.95);
}
.users-page-container .create-user-fab .icon {
  color: white;
}
html[data-coreui-theme=dark] .users-page-container .page-header {
  border-bottom-color: var(--cui-dark-border-subtle, #333);
}
html[data-coreui-theme=dark] .users-page-container .page-header .page-title h2 {
  color: var(--cui-body-color);
}
html[data-coreui-theme=dark] .users-page-container .page-header .page-title .text-muted {
  color: var(--cui-secondary-color);
}
html[data-coreui-theme=dark] .users-page-container .create-user-fab {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
}
html[data-coreui-theme=dark] .users-page-container .create-user-fab:hover {
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.5);
}
@media (max-width: 768px) {
  .users-page-container {
    padding: 0.5rem 0;
  }
  .users-page-container .page-header {
    margin-bottom: 1.5rem;
    padding-bottom: 0.75rem;
  }
  .users-page-container .page-header .page-title h2 {
    font-size: 1.5rem;
  }
  .users-page-container .page-header .page-title .text-muted {
    font-size: 0.8125rem;
  }
  .users-page-container .create-user-fab {
    bottom: 16px;
    right: 16px;
    width: 48px;
    height: 48px;
  }
}
@media (max-width: 576px) {
  .users-page-container .page-header {
    margin-bottom: 1rem;
  }
  .users-page-container .page-header .page-title h2 {
    font-size: 1.25rem;
  }
}
.users-page-container .users-page-container {
  animation: fadeInUp 0.4s ease-out;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.users-page-container .loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}
.users-page-container .loading-container .loading-content {
  text-align: center;
  color: var(--cui-secondary-color);
}
.users-page-container .loading-container .loading-content .loading-spinner {
  margin-bottom: 1rem;
}
.users-page-container .loading-container .loading-content .loading-text {
  font-size: 1rem;
  font-weight: 500;
}
.users-page-container .error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}
.users-page-container .error-container .error-content {
  text-align: center;
  color: var(--cui-danger);
}
.users-page-container .error-container .error-content .error-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.7;
}
.users-page-container .error-container .error-content .error-text {
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}
.users-page-container .error-container .error-content .error-subtext {
  font-size: 0.875rem;
  color: var(--cui-secondary-color);
}
.users-page-container .stats-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}
.users-page-container .stats-container .stat-card {
  background: var(--cui-card-bg);
  border: 1px solid var(--cui-border-color);
  border-radius: 8px;
  padding: 1.5rem;
  transition: all 0.2s ease;
}
.users-page-container .stats-container .stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.users-page-container .stats-container .stat-card .stat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.users-page-container .stats-container .stat-card .stat-header .stat-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--cui-secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.users-page-container .stats-container .stat-card .stat-header .stat-icon {
  color: var(--cui-primary);
  opacity: 0.7;
}
.users-page-container .stats-container .stat-card .stat-value {
  font-size: 2rem;
  font-weight: 700;
  color: var(--cui-body-color);
  margin-bottom: 0.5rem;
}
.users-page-container .stats-container .stat-card .stat-change {
  font-size: 0.875rem;
}
.users-page-container .stats-container .stat-card .stat-change.positive {
  color: var(--cui-success);
}
.users-page-container .stats-container .stat-card .stat-change.negative {
  color: var(--cui-danger);
}
.users-page-container .stats-container .stat-card .stat-change.neutral {
  color: var(--cui-secondary-color);
}`, "",{"version":3,"sources":["webpack://./src/pages/Users/Users.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,iBAAA;EACA,eAAA;AACJ;AACI;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yDAAA;AACN;AACM;EACE,SAAA;AACR;AACQ;EACE,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AACV;AAEQ;EACE,mBAAA;EACA,0CAAA;AAAV;AAIM;EACE,cAAA;AAFR;AAIQ;EACE,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;AAFV;AAIU;EACE,2BAAA;EACA,wCAAA;AAFZ;AASI;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,YAAA;AAPN;AASM;EACE,qBAAA;EACA,yCAAA;AAPR;AAUM;EACE,sBAAA;AARR;AAWM;EACE,YAAA;AATR;AAeM;EACE,wDAAA;AAbR;AAgBU;EACE,4BAAA;AAdZ;AAiBU;EACE,iCAAA;AAfZ;AAoBM;EACE,yCAAA;AAlBR;AAoBQ;EACE,yCAAA;AAlBV;AAwBI;EAtGJ;IAuGM,iBAAA;EArBJ;EAuBI;IACE,qBAAA;IACA,uBAAA;EArBN;EAwBQ;IACE,iBAAA;EAtBV;EAyBQ;IACE,oBAAA;EAvBV;EA4BI;IACE,YAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;EA1BN;AACF;AA6BI;EACE;IACE,mBAAA;EA3BN;EA8BQ;IACE,kBAAA;EA5BV;AACF;AAkCI;EACE,iCAAA;AAhCN;AAmCI;EACE;IACE,UAAA;IACA,2BAAA;EAjCN;EAmCI;IACE,UAAA;IACA,wBAAA;EAjCN;AACF;AAqCI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAnCN;AAqCM;EACE,kBAAA;EACA,iCAAA;AAnCR;AAqCQ;EACE,mBAAA;AAnCV;AAsCQ;EACE,eAAA;EACA,gBAAA;AApCV;AA0CI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAxCN;AA0CM;EACE,kBAAA;EACA,wBAAA;AAxCR;AA0CQ;EACE,eAAA;EACA,mBAAA;EACA,YAAA;AAxCV;AA2CQ;EACE,mBAAA;EACA,gBAAA;EACA,qBAAA;AAzCV;AA4CQ;EACE,mBAAA;EACA,iCAAA;AA1CV;AAgDI;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AA9CN;AAgDM;EACE,8BAAA;EACA,yCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AA9CR;AAgDQ;EACE,2BAAA;EACA,yCAAA;AA9CV;AAiDQ;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AA/CV;AAiDU;EACE,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;AA/CZ;AAkDU;EACE,yBAAA;EACA,YAAA;AAhDZ;AAoDQ;EACE,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,qBAAA;AAlDV;AAqDQ;EACE,mBAAA;AAnDV;AAqDU;EACE,yBAAA;AAnDZ;AAsDU;EACE,wBAAA;AApDZ;AAuDU;EACE,iCAAA;AArDZ","sourcesContent":[".users-page-container {\n    position: relative;\n    min-height: 100vh;\n    padding: 1rem 0;\n  \n    .page-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-end;\n      margin-bottom: 2rem;\n      padding-bottom: 1rem;\n      border-bottom: 1px solid var(--cui-border-color, #d8dbe0);\n  \n      .page-title {\n        flex: 1;\n  \n        h2 {\n          color: var(--cui-body-color);\n          font-weight: 600;\n          font-size: 1.75rem;\n          margin-bottom: 0.25rem;\n        }\n  \n        .text-muted {\n          font-size: 0.875rem;\n          color: var(--cui-secondary-color, #8a93a2);\n        }\n      }\n  \n      .page-actions {\n        flex-shrink: 0;\n  \n        .btn {\n          font-weight: 500;\n          padding: 0.5rem 1rem;\n          border-radius: 6px;\n          transition: all 0.2s ease;\n  \n          &:hover {\n            transform: translateY(-1px);\n            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n          }\n        }\n      }\n    }\n  \n    // Floating Action Button\n    .create-user-fab {\n      position: fixed;\n      bottom: 24px;\n      right: 24px;\n      width: 56px;\n      height: 56px;\n      border-radius: 50%;\n      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n      z-index: 1000;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.3s ease;\n      border: none;\n      \n      &:hover {\n        transform: scale(1.1);\n        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);\n      }\n  \n      &:active {\n        transform: scale(0.95);\n      }\n  \n      .icon {\n        color: white;\n      }\n    }\n  \n    // Dark theme support\n    html[data-coreui-theme=\"dark\"] & {\n      .page-header {\n        border-bottom-color: var(--cui-dark-border-subtle, #333);\n  \n        .page-title {\n          h2 {\n            color: var(--cui-body-color);\n          }\n  \n          .text-muted {\n            color: var(--cui-secondary-color);\n          }\n        }\n      }\n  \n      .create-user-fab {\n        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);\n        \n        &:hover {\n          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.5);\n        }\n      }\n    }\n  \n    // Responsive design\n    @media (max-width: 768px) {\n      padding: 0.5rem 0;\n  \n      .page-header {\n        margin-bottom: 1.5rem;\n        padding-bottom: 0.75rem;\n  \n        .page-title {\n          h2 {\n            font-size: 1.5rem;\n          }\n  \n          .text-muted {\n            font-size: 0.8125rem;\n          }\n        }\n      }\n  \n      .create-user-fab {\n        bottom: 16px;\n        right: 16px;\n        width: 48px;\n        height: 48px;\n      }\n    }\n  \n    @media (max-width: 576px) {\n      .page-header {\n        margin-bottom: 1rem;\n  \n        .page-title {\n          h2 {\n            font-size: 1.25rem;\n          }\n        }\n      }\n    }\n  \n    // Animation for page load\n    .users-page-container {\n      animation: fadeInUp 0.4s ease-out;\n    }\n  \n    @keyframes fadeInUp {\n      from {\n        opacity: 0;\n        transform: translateY(20px);\n      }\n      to {\n        opacity: 1;\n        transform: translateY(0);\n      }\n    }\n  \n    // Loading states\n    .loading-container {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      min-height: 400px;\n      \n      .loading-content {\n        text-align: center;\n        color: var(--cui-secondary-color);\n        \n        .loading-spinner {\n          margin-bottom: 1rem;\n        }\n        \n        .loading-text {\n          font-size: 1rem;\n          font-weight: 500;\n        }\n      }\n    }\n  \n    // Error states\n    .error-container {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      min-height: 400px;\n      \n      .error-content {\n        text-align: center;\n        color: var(--cui-danger);\n        \n        .error-icon {\n          font-size: 3rem;\n          margin-bottom: 1rem;\n          opacity: 0.7;\n        }\n        \n        .error-text {\n          font-size: 1.125rem;\n          font-weight: 500;\n          margin-bottom: 0.5rem;\n        }\n        \n        .error-subtext {\n          font-size: 0.875rem;\n          color: var(--cui-secondary-color);\n        }\n      }\n    }\n  \n    // Statistics cards (if needed for future enhancement)\n    .stats-container {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n      gap: 1rem;\n      margin-bottom: 2rem;\n  \n      .stat-card {\n        background: var(--cui-card-bg);\n        border: 1px solid var(--cui-border-color);\n        border-radius: 8px;\n        padding: 1.5rem;\n        transition: all 0.2s ease;\n  \n        &:hover {\n          transform: translateY(-2px);\n          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n        }\n  \n        .stat-header {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          margin-bottom: 1rem;\n  \n          .stat-title {\n            font-size: 0.875rem;\n            font-weight: 600;\n            color: var(--cui-secondary-color);\n            text-transform: uppercase;\n            letter-spacing: 0.5px;\n          }\n  \n          .stat-icon {\n            color: var(--cui-primary);\n            opacity: 0.7;\n          }\n        }\n  \n        .stat-value {\n          font-size: 2rem;\n          font-weight: 700;\n          color: var(--cui-body-color);\n          margin-bottom: 0.5rem;\n        }\n  \n        .stat-change {\n          font-size: 0.875rem;\n          \n          &.positive {\n            color: var(--cui-success);\n          }\n          \n          &.negative {\n            color: var(--cui-danger);\n          }\n          \n          &.neutral {\n            color: var(--cui-secondary-color);\n          }\n        }\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
